import {createAction} from '../../base/fsa';

export const setTemperatureAction = createAction(
    resolve => (icon, temperature) => resolve({icon, temperature}),
);
